import Vue from 'vue'
import Vuex from 'vuex'
import jsCookie from 'js-cookie'
import { cart } from '@/api/app'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  state: {
    //存放的键值对就是所要管理的状态
    name: 'helloVueX',
    login_status: false,
    user_info: {},
    purchase_list: {},
    search_status: 0,
    search_type: 0,
    pk_status: 0,
    Authorization: sessionStorage.getItem('Authorization')
      ? sessionStorage.getItem('Authorization')
      : '',
    loading_sum: 40,
    wsmemberId: '',
    isNewMessage:false
  },
  getters: {
    getUserInfo(state) {
      return state.user_info
    },
  },
  mutations: {
    changeWsMemberId(state, wsmemberId) {
      state.wsmemberId = wsmemberId
    },
    changeLogintwo(state, user) {
      state.Authorization = user.Authorization
      sessionStorage.setItem('Authorization', user.Authorization)
      jsCookie.set('Authorization', user.Authorization)
    },
    changeLogin(state, login_status) {
      //  0 未登录  1  登录
      if (login_status == 0) {
        state.login_status = false
      } else {
        state.login_status = true
      }
    },
    changeIsMessage(state,isnew){
      //  0 没有新消息  1  新消息
      if (isnew == 0) {
        state.isNewMessage = false
      } else {
        state.isNewMessage = true
      }
    },
    setUserInfo(state, user_info) {
      state.user_info = user_info
    },
    setPurchaselist(state, purchase_list) {
      state.purchase_list = purchase_list
    },
    addSearchstatus(state) {
      state.search_status++
    },
    changeSearchtype(state, search_type) {
      state.search_type = search_type
    },
    changePkstatus(state) {
      state.pk_status++
    },
    clearLoading(state, loading_sum) {
      state.loading_sum = loading_sum
    },
  },
  actions: {
    // 是否登录
    getLoginStatus({ commit, state }) {
      return new Promise((resolve, reject) => {
        cart()
          .then((res) => {
            if (res.success) {
                commit("changeLogin", 1);
                commit("setPurchaselist", res.result);
            } else {
                commit("changeLogin", 0);
                commit("setPurchaselist", {});
            }
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js